import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { AUTH_KEY, getCookieValue } from '@classity-edtech/ui-base';
import { webPaths } from '../../routes/paths';

export const ProtectedRoute = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const clientId = getCookieValue(AUTH_KEY);

    if (!clientId) {
      navigate(`${webPaths.root}`, { replace: true });
    }
  }, [navigate]);

  return <Outlet />;
};
